import React from 'react';
import { IDateTimeFormatter } from '../../../../../infrastructure/date-formatter';
import { getFormattedDatesString } from '../../../../../infrastructure/utils/date.util';
import DefaultButton from '../../../../global/default-button/default-button';
import './_event-name-column.scss';
import Text from '../../../../global/text/text';
import { hasPermission } from '../../../../../infrastructure/utils/has-permissions';
import { Permission } from '../../../../../api/roles.dao';
import classNames from 'classnames';
import { editText } from '../../../../../constants/common-labels.constants';

interface IProps {
    name: string;
    startDateTime?: Date;
    endDateTime?: Date;
    timeZone?: string;
    onEditEvent: () => void;
    handleClick?: () => void;
    dateFormatter?: IDateTimeFormatter;
    searchQuery?: string;
    className?: string;
    wrapperClassName?: string;
}

const EventNameColumn = (props: IProps) => {
    const {
        name,
        startDateTime,
        endDateTime,
        timeZone,
        onEditEvent,
        handleClick,
        searchQuery,
        className,
        wrapperClassName
    } = props;

    const editPermission = hasPermission(Permission.EDIT_EVENT);

    return (
        <div className={classNames('event-name-column', wrapperClassName)}>
            <div className='event-name-column__text-with-edit'>
                <Text
                    className={classNames('event-name-column__text', className)}
                    message={name}
                    highlightValue={searchQuery}
                    withEllipsis
                    withHighlight
                    onClick={handleClick}
                />
                {
                    editPermission &&
                    <DefaultButton
                        className='visible-while-hovered'
                        modifier={['slim', 'link']}
                        text={editText()}
                        onClick={onEditEvent}
                    />
                }
            </div>
            {
                startDateTime &&
                <span className='event-name-column__day stringified-day'>
                    {getFormattedDatesString(startDateTime, endDateTime, timeZone, true)}
                </span>
            }
        </div>
    );
};

export default EventNameColumn;
